import modalElement from "../../modals/modal";
import ModalBase from "../../abstracts/modalBase";
import QuizCtrl from "../../quizGame/quizCtrl";

export default class ModalQuiz extends ModalBase {
    private static idModal = "modal-quiz";
    private static dimension = "modal-large";
    protected static modalTitle = "Quiz";
    private static elementToRender = modalElement(
        ModalQuiz.idModal,
        ModalQuiz.dimension,
        ModalQuiz.modalTitle
    );
    
    constructor(protected container){
        super(
            ModalQuiz.modalTitle,
            container,
            ModalQuiz.idModal,
            ModalQuiz.elementToRender
        );
    }

    public loadBody(cb?:()=>void){
        new QuizCtrl(this.modalBody).rederInitialPage();
    }
}